export const PAYMENT_METHOD_TYPE = Object.freeze({
	BANK_ACCOUNT: "BANK_ACCOUNT",
	CREDIT_CARD: "CREDIT_CARD",
	DEBIT_CARD: "DEBIT_CARD"
});

export const BANK_ACCOUNT_TYPE = Object.freeze({
	CHECKING: "CHECKING",
	SAVINGS: "SAVINGS"
});

export const SUPPORTED_COUNTRIES = Object.freeze({
	US: "US",
	CA: "CA"
});

export const CARD_BRANDS = Object.freeze({
	VISA: "Visa",
	MASTERCARD: "Mastercard",
	AMERICAN_EXPRESS: "American Express",
	DINERS_CLUB: "Diners Club",
	DISCOVER: "Discover",
	JCB: "JCB",
	UNION_PAY: "UnionPay",
	MAESTRO: "Maestro",
	DEBIT: "Debit"
});
